import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { roleBasedNotificationsRoute } from '@jira/router-routes__eoc-role-based-notifications-routes/src/roleBasedNotificationsRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { resources as roleBasedNotificationsResources } from '@atlassian/eoc-role-based-notifications/resources';
import type { Route } from '@atlassian/react-resource-router';
import {
	LazyRoleBasedNotifications,
	RoleBasedNotificationsComponent,
} from './ui/RoleBasedNotificationsComponent.tsx';

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const roleBasedNotificationsRouteEntry: Route = createEntry(
	roleBasedNotificationsRoute,
	() => ({
		group: 'eoc',
		// eslint-disable-next-line no-restricted-syntax
		component: RoleBasedNotificationsComponent,
		layout: opsSettingsLayout,

		resources: [
			...getNavigationResources(),
			roleBasedNotificationsResources[0],
			getConsolidationStateResource(),
			navigationSidebarGlobalResource,
		],

		navigation: {
			menuId: MenuIdSettings,
			...getNavigationSpecifications(),
		},

		forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyRoleBasedNotifications],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
